import { render, staticRenderFns } from "./NoteContainer.vue?vue&type=template&id=d5bfb29a&"
import script from "./NoteContainer.vue?vue&type=script&lang=js&"
export * from "./NoteContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports